import type {
  RouteLocationNormalizedLoaded,
  RouteLocationRaw,
} from 'vue-router'

export const DEFAULT_MENU_NAME = 'Draft'

export const MENU_ROUTE_NAMES = [
  'Draft',
  'Send',
  'Consume',
  'PushSettings',
  'UserGuide',
] as const

export type MenuName = (typeof MENU_ROUTE_NAMES)[number]

const pageTypeMenuNameMap: Record<string, MenuName> = {
  DRAFT_PAGE: 'Draft',
  SEND_PAGE: 'Send',
}

const routeNameMenuNameMap: Record<string, MenuName> = {
  Draft: 'Draft',
  Send: 'Send',
  Detail: 'Draft',
  MasterDetail: 'Draft',
  MasterHistory: 'Send',
  MasterHistoryDetail: 'Send',
  SentHistory: 'Send',
  HistoryDetail: 'Send',
  Consume: 'Consume',
  PushSettings: 'PushSettings',
  UserGuide: 'UserGuide',
}

type RouteLike = Partial<
  Pick<RouteLocationNormalizedLoaded, 'name' | 'query' | 'params' | 'meta'>
> &
  RouteLocationRaw

export const resolveMenuName = (
  route?: RouteLike,
  fallback: MenuName = DEFAULT_MENU_NAME,
): MenuName => {
  if (!route || typeof route !== 'object') return fallback
  const query = 'query' in route ? route.query : undefined
  const pageType = query?.pageType as string | undefined
  if (pageType && pageTypeMenuNameMap[pageType]) {
    return pageTypeMenuNameMap[pageType]
  }

  const name = 'name' in route ? route.name : undefined
  if (typeof name === 'string' && routeNameMenuNameMap[name]) {
    return routeNameMenuNameMap[name]
  }

  return fallback
}

export const resolveTabKey = (route?: RouteLike) => {
  if (!route || typeof route !== 'object') return String(Date.now())
  const name = 'name' in route ? route.name : undefined
  const params = 'params' in route ? route.params : undefined
  const query = 'query' in route ? route.query : undefined
  const id = params?.id || query?.id || Date.now()
  return [name, id].filter(Boolean).join('_')
}
